<template>
  <el-dialog class="recommendedLineForm" title="创建推荐线路" :visible.sync="p_visible" width="1000px"
    :close-on-click-modal="false" :before-close="close">

    <div class="flex">
      <div>
        <div>
          <span class="redcheck">展示区域</span>
          <el-select v-model="city" :disabled="p_city != null" filterable>
            <el-option v-for="city in citys" :key="city.city" :label="city.city" :value="city.city"></el-option>
          </el-select>
        </div>
        <div>
          <span>备注</span>
          <el-input v-model="remark" maxlength="20" placeholder="输入备注内容" />
        </div>
      </div>

      <el-button type="primary" @click="add">添加线路</el-button>
    </div>

    <div class="tips">说明：可设置地区独立展示的推荐线路，地区展示优先级高于全国</div>

    <el-table border empty-text="暂无数据" :data="tableData">
      <el-table-column label="顺序" type="index"></el-table-column>
      <el-table-column label="机构名称" prop="organizationName"></el-table-column>
      <el-table-column label="出发地" prop="startStationName" v-slot="{ row }">
        <div>{{ row.startStationName }}</div>
        <div style="color: #999">{{ row.startProvincialCity }}</div>
      </el-table-column>
      <el-table-column label="目的地" prop="endStationName" v-slot="{ row }">
        <div>{{ row.endStationName }}</div>
        <div style="color: #999">{{ row.endProvincialCity }}</div>
      </el-table-column>
      <el-table-column label="展示名称" prop="showName">
        <template slot="header">
          <div style="display: flex;align-items: center;">
            <span>展示名称</span>
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question util-remark" style="font-size: 20px; padding-left: 6px"></i>
              <div slot="content" style="line-height: 1.6">
                展示给用户看的名称，建议简化（例如 北京-天津）
              </div>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="{ row }">
          <el-input v-model="row.showName" maxlength="12" placeholder="输入展示名称" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" v-slot="{ $index }">
        <el-button v-if="$index > 0"
          @click="[tableData[$index - 1], tableData[$index]] = [tableData[$index], tableData[$index - 1]]; tableData.splice(tableData.length, 0)"
          type="text" size="small">上移</el-button>
        <el-button v-if="$index < tableData.length - 1"
          @click="[tableData[$index + 1], tableData[$index]] = [tableData[$index], tableData[$index + 1]]; tableData.splice(tableData.length, 0)"
          type="text" size="small">下移</el-button>
        <el-button type="text" size="small" @click="tableData.splice($index, 1)">删除</el-button>
      </el-table-column>
    </el-table>

    <div style="margin-top: 16px; text-align: right;">
      <el-button type="primary" @click="save">确 定</el-button>
    </div>

    <el-dialog title="添加线路" :visible.sync="visibleLines" width="1000px" append-to-body :close-on-click-modal="false"
      :before-close="linesClose">
      <el-checkbox-group v-model="checkLines">
        <custom-table v-if="p_visible" ref="customTable" :customOptions="customOptions" :columns="columns"
          labelWidth="140" has-organization="true"  :show-overflow-tooltip="false" addText=""
          layout="total, prev, pager, next" maxHeight="450" @onRowClick="onRowClick">

          <template slot-scope="{ item, row }">
            <span v-if="item.prop === 'startStationName'">
              <div>{{ row.startStationName }}</div>
              <div style="color: #999">{{ row.startProvincialCity }}</div>
            </span>
            <span v-else-if="item.prop === 'endStationName'">
              <div>{{ row.endStationName }}</div>
              <div style="color: #999">{{ row.endProvincialCity }}</div>
            </span>
            <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
          </template>

          <template slot="table-operation">
            <el-table-column label="操作" width="80" fixed="right" v-slot="{ row }">
              <el-checkbox :label="row" @change="onRowClick(row)">ㅤ</el-checkbox>
            </el-table-column>
          </template>
        </custom-table>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="linesPush">确 定</el-button>
      </span>
    </el-dialog>

  </el-dialog>
</template>

<script>
import provinceCitys from "../../../public/provinceCitys";
export default {
  name: "recommendedLineForm",
  props: {
    p_visible: Boolean,
    p_id: Number,
    p_city: String,
    p_remark: String
  },
  data() {
    return {
      citys: [],
      city: null,
      remark: null,
      tableData: [],

      visibleLines: false,
      loading: false,
      customOptions: {
        url: "/api/v1/manage/line/recommend/line",
        params: {
          page: 1,
          size: 20,
        },
        search: [
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
        ],
      },
      columns: [
        { prop: "startStationName", label: "出发地" },
        { prop: "endStationName", label: "目的地" },
      ],
      checkLines: []
    };
  },
  watch: {
    p_visible: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            if (this.p_id) {
              this.city = this.p_city;
              this.remark = this.p_remark;
              this.getTable();
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getCitys();
  },
  methods: {

    // 筛选可选城市列表
    getCitys() {
      let zhixia = ['北京市', '上海市', '重庆市', '天津市']
      let iteration = (list) => {
        let cityList = [];
        list.map(province => {
          if (zhixia.includes(province.label)) {
            // 直辖市直接返回
            cityList.push({
              province: province.label,
              city: province.label,
              cityCode: province.value
            })
          } else {
            province.children.map(city => {
              cityList.push({
                province: province.label,
                city: city.label,
                cityCode: city.value
              })
            })
          }
        })

        cityList.unshift({ city: '全国' })
        return cityList;
      }

      this.citys = iteration(provinceCitys[0])
    },

    /* 获取已保存的区域推荐线路 */
    async getTable() {
      let url = "/api/v1/manage/line/recommend";
      let params = { lineRecommendAreaId: this.p_id }
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        this.tableData = data.data;
      }
    },

    /* 新增线路点击行 */
    onRowClick(row) {
      let index = this.checkLines.findIndex(item => item.id == row.id)
      if (index == -1) {
        this.checkLines.push(row)
      } else {
        this.checkLines.splice(index, 1)
      }
    },

    /* 新增区域推荐线路 */
    linesPush() {
      this.visibleLines = false;
      this.checkLines.map(item => item.lineId = item.id)
      this.tableData = this.tableData.concat(JSON.parse(JSON.stringify(this.checkLines)))
      this.checkLines = [];
    },

    linesClose() {
      this.visibleLines = false;
      this.checkLines = [];
    },

    add() {
      this.visibleLines = true;
    },

    async save() {
      if (!this.city) {
        this.$message.warning("请选择展示区域");
        return;
      }
      if (this.tableData.length == 0) {
        this.$message.warning("请添加线路后保存");
        return;
      }
      let bl = this.tableData.findIndex(item => !item.showName)
      if (bl > -1) {
        this.$message.warning("请检查展示名称是否完整");
        return;
      }


      let tableData = JSON.parse(JSON.stringify(this.tableData))
      tableData.map((item, index) => item.sort = index + 1)

      let url = "/api/v1/manage/line/recommend";
      let params = {
        lineRecommendAreaId: this.p_id,
        city: this.city,
        cityCode: this.citys.find(item => item.city == this.city).cityCode,
        lineRecommend: JSON.stringify(tableData),
        remark: this.remark
      }
      let data = await this.$axios[this.p_id ? 'put' : 'post'](url, params);
      if (data && data.code == 1) {
        this.$message.success("已保存");
        this.close();
      }
    },

    close() {
      this.city = null;
      this.remark = null;
      this.tableData = [];
      this.$emit('closeFn')
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &>div {
    display: flex;
    align-items: center;

    &>* {
      display: flex;
      align-items: center;
      margin-right: 50px;

      span {
        margin-right: 10px;
        flex-shrink: 0;
      }
    }
  }
}

.tips {
  margin-bottom: 16px;
}
</style>
